<script lang="ts">
    import type {InputDescription} from './types';

    export let inputDescription: InputDescription | null;
</script>

<template>
    {#if !!inputDescription}
        <span id={inputDescription.id} class="help-block editor-description">{inputDescription.content}</span>
    {/if}
</template>
